export const puapParts = [
"Engine",
"Transmission",
"Instrument Cluster",
"Air Bag",
"Steering Column",
"Abs module",
"driveshaft",
"Transfer Case",
"Steering Rack/Box/Gear",
"Exhaust Manifold",
"Carrier",
"Cylinder Head",
"CV Axle Shaft",
"Struts",
"Climate Control Module",
"Mirror Door",
"Front Differential",
"Rear Differential",
"Rear Axle Assembly (Rear End)",
"Front Axle Assembly",
"Others"
  ];